"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInputBase = void 0;
var react_1 = __importDefault(require("react"));
var css_1 = require("@emotion/css");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var InputBottomRow_1 = require("../InputModules/InputBottomRow");
var Help_1 = require("../InputModules/Help");
var Adornment_1 = require("../InputModules/Adornment");
var shared_1 = require("../shared");
var helperFunctions_1 = require("../utils/helperFunctions");
var TextInputBase = function (_a) {
    var ariaLabel = _a["aria-label"], componentName = _a.componentName, className = _a.className, ContainerProps = _a.ContainerProps, containerRef = _a.containerRef, endAdornment = _a.endAdornment, error = _a.error, guidance = _a.guidance, help = _a.help, isDisabled = _a.isDisabled, label = _a.label, placeholder = _a.placeholder, startAdornment = _a.startAdornment, style = _a.style, testId = _a.testId, units = _a.units, uniqueId = _a.uniqueId, children = _a.children;
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    (0, helperFunctions_1.validateInputLabelAccessibility)(componentName, label, ariaLabel);
    return (react_1.default.createElement("div", __assign({ className: (0, css_1.cx)(shared_1.inputContainerStyles, 'ds-text-input'), style: style, "data-testid": testId && "".concat(testId, "-container"), ref: containerRef }, ContainerProps),
        react_1.default.createElement("div", { className: shared_1.inputTopRowStyles, "data-testid": testId && "".concat(testId, "-top-row") },
            react_1.default.createElement(Help_1.Help, __assign({ id: uniqueId, testId: testId }, help))),
        react_1.default.createElement("div", { "data-testid": testId && "".concat(testId, "-input-wrapper"), className: (0, css_1.cx)((0, shared_1.inputWrapperStyles)(label, selectedTheme), !placeholder && (0, shared_1.labelAsPlaceholderStyles)(selectedTheme), error && (0, shared_1.inputErrorStyles)(selectedTheme), isDisabled && (0, shared_1.inputDisabledStyles)(selectedTheme), className) },
            react_1.default.createElement(Adornment_1.Adornment, { position: 'start', render: startAdornment, testId: testId }),
            children,
            react_1.default.createElement("label", { "data-testid": testId && "".concat(testId, "-label"), htmlFor: uniqueId }, label),
            react_1.default.createElement("fieldset", null, label && react_1.default.createElement("legend", null, label)),
            react_1.default.createElement(Adornment_1.Adornment, { position: 'end', render: endAdornment, testId: testId })),
        react_1.default.createElement(InputBottomRow_1.InputBottomRow, { error: error, units: units, guidance: guidance, id: uniqueId, isDisabled: isDisabled, testId: testId })));
};
exports.TextInputBase = TextInputBase;
exports.TextInputBase.displayName = 'StringInputBase';
